export { default } from "./LastEditInfoLabel";
